import './MobileNavbar.scss';

import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import Icon from 'atoms/icon';
import { closeDrawer, openDrawer } from 'store/reducers/ui';

export function MobileNavbar({ variant, burgerColor = 'black' }) {
  const dispatch = useDispatch();
  const { isOpen } = useSelector((state) => state.ui.drawer);

  const openNavbarDrawer = () => {
    if (isOpen) {
      return dispatch(closeDrawer());
    }
    dispatch(openDrawer({ type: 'navbar', position: 'right' }));
  };

  const isWhiteVariant = isOpen;

  return (
    <div
      className={classNames(
        'mobile-burger w-100',
        isOpen && 'mobile-burger--open',
        `mobile-burger--${variant}`
      )}
    >
      <div className="flex-row justify-between w-100">
        <Link to="/">
          <Icon
            name="pawcare"
            style={{
              width: 125,
              height: '100%',
              variant: isWhiteVariant ? 'black' : 'white',
              outterColor: isWhiteVariant ? 'white' : 'black',
            }}
          />
        </Link>
        <Icon
          name="burger"
          fill={isWhiteVariant ? 'white' : burgerColor}
          onClick={openNavbarDrawer}
        />
      </div>
    </div>
  );
}
